// extracted by mini-css-extract-plugin
export default {"ServiceTemp":"Temp_ServiceTemp__-Bfau","ServiceImage":"Temp_ServiceImage__8tlIe","TempName":"Temp_TempName__R6Z1o","ServiceText":"Temp_ServiceText__dVqG-"};